import { render, staticRenderFns } from "./DopplerEffectViz.vue?vue&type=template&id=96d406cc&scoped=true"
import script from "./DopplerEffectViz.vue?vue&type=script&lang=js"
export * from "./DopplerEffectViz.vue?vue&type=script&lang=js"
import style0 from "./DopplerEffectViz.vue?vue&type=style&index=0&id=96d406cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d406cc",
  null
  
)

export default component.exports